import { Link } from "react-router-dom";
import { useUserXp } from "../../hooks/useUserXp";
import styles from "./header.module.scss";

// The link is the 44px-tall hit area; the visible chip (~28px) lives inside it
// so the touch target stays comfortable without a chunky pill. Below 380px the
// chip reads "Lv N" instead of "Level N" (both are in the DOM, CSS picks one -
// the link's aria-label is what assistive tech announces either way).
export default function LevelBadge() {
    const { status, progress, hasProgress } = useUserXp();
    if (status === "signed-out") return null;
    const hasLevel = hasProgress;
    return <Link to="/profile" className={styles.levelBadge}
        aria-label={hasLevel ? `Learning level ${progress.level}, ${progress.xp} XP. View profile` : "View your learning level on your profile"}
        aria-busy={status === "loading" ? "true" : undefined}
        title={hasLevel ? `${progress.xp} XP` : undefined}>
        <span className={`${styles.levelChip}${hasLevel ? ` ${styles.levelBadgeEarned}` : ""}`}>
            {hasLevel ? (
                <>
                    <span className={styles.levelLong}>Level {progress.level}</span>
                    <span className={styles.levelShort}>Lv {progress.level}</span>
                </>
            ) : (
                <span>Your level</span>
            )}
            {status === "loading" && <span className={styles.levelSpinner} aria-hidden="true" />}
        </span>
    </Link>;
}
